import React from 'react';
import PropTypes from 'prop-types';
import { MpgEntities } from 'client/data/models/mpg';
import { MPGE_ENGINES } from 'site-modules/shared/constants/mpg';

export function SeoStylesMpg({ styles, vehicleName }) {
  return (
    <div className="seo-styles-mpg" aria-hidden style={{ display: 'none' }}>
      {styles.map(({ id, trimName, engineType, mpgData, mpgeData }) => {
        const isMpge = MPGE_ENGINES.includes(engineType);
        const { combined, city, highway } = isMpge ? mpgeData : mpgData;

        return (
          <div key={id}>
            <h2>
              {vehicleName} {trimName}{' '}
            </h2>
            <div>
              {combined || 'N/A'} MPG{isMpge && 'e*'} EPA Combined City/Hwy
              {city || 'N/A'} City
              {highway || 'N/A'} Highway
            </div>
            {isMpge && <div>* Miles per gallon equivalent. 1 MPGe = 1 mi / 33.7 kWh</div>}
          </div>
        );
      })}
    </div>
  );
}

SeoStylesMpg.propTypes = {
  styles: PropTypes.arrayOf(MpgEntities.StyleMpg).isRequired,
  vehicleName: PropTypes.string.isRequired,
};
